import script from "./CommonWageReportExcel.vue?vue&type=script&setup=true&lang=ts"
export * from "./CommonWageReportExcel.vue?vue&type=script&setup=true&lang=ts"

import "./CommonWageReportExcel.vue?vue&type=style&index=0&id=3e1c93bb&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e1c93bb"]])

export default __exports__